__turbopack_context__.v({
  "comboList": "comboList-module-scss-module__mEvZsa__comboList",
  "comboListEmpty": "comboList-module-scss-module__mEvZsa__comboListEmpty",
  "comboListTitle": "comboList-module-scss-module__mEvZsa__comboListTitle",
});
